export default {
  PUBLIC_URL_GETTING_STARTED:
    'https://messagespring.crisp.help/en/category/getting-started-1m639i5/',
  PUBLIC_URL_FAQ:
    'https://messagespring.crisp.help/en/category/general-faq-11nysb0/',
  PUBLIC_URL_TROUBLE_SHOOTING_GUIDE:
    'https://messagespring.crisp.help/en/category/troubleshooting-guide-kc4tfb/',
}
